import './style.sass';

import parse from 'html-react-parser';
import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonCollapseItem from '../../../common-components/common-collapse-item';

const processList = [
    {
        title: `Мониторинг основных ранжируемых страниц`,
        subtitle: `Мы&nbsp;отслеживали позиции, код ответа сервера, изменения контента и&nbsp;мета-тегов на&nbsp;страницах.`,
    },
    {
        title: `Общий мониторинг сайта`,
        subtitle: `Отслеживали появление в&nbsp;индексе количества страниц, появление 404&nbsp;страниц, корректность и&nbsp;наличие robots.txt, sitemap.`,
    },
    {
        title: `Сбор основы семантического ядра`,
        subtitle: `В&nbsp;основе семантического ядра легли около 500 фраз о&nbsp;ПИФах и&nbsp;инвестициях. Отдельно мы&nbsp;собрали информационные ключевые слова про сравнение вкладов, голубые фишки, облигации и&nbsp;другие ценные бумаги.`,
    },
    {
        title: `Доработка семантики и ее кластеризация`,
        subtitle: `Сгруппировали семантику на&nbsp;тематические смысловые блоки, добавили в&nbsp;группы еще новых ключевых фраз. Из&nbsp;этой группировки сформировали структуру сайта и&nbsp;рекомендации к&nbsp;новым посадочным страницам.`,
    },
    {
        title: `Точечные рекомендации для существующих посадочных страниц.`,
        subtitle: `В&nbsp;соответствии с&nbsp;ключевыми словами для существующих страниц сформировали корректные мета-теги и&nbsp;заголовки, дали рекомендации по&nbsp;перелинковке.`,
    },
    {
        title: `Закупка ссылок`,
        subtitle: `Особенность стратегии закупок внешних ссылок&nbsp;&mdash; это высокая нативность и&nbsp;информационное поле, которое не&nbsp;должно противоречить политике бренда при размещении ссылок. Нельзя размещать ссылки на&nbsp;сайт в&nbsp;контексте непрофильных материалов, которые могут оказать негативное влияние на&nbsp;имидж или деловую репутацию клиента. Поэтому мы&nbsp;сделали ставку на&nbsp;нативность и&nbsp;закупили статьи на&nbsp;медиа-порталах, таких как: Rusbase, Эксперт.ру, Бизнес Газета и&nbsp;подобные. Помимо порталов мы&nbsp;взяли в&nbsp;работу закупку постов у&nbsp;блогеров на&nbsp;каналах: Instagram, Telegram и&nbsp;Яндекс.Дзен.`,
    },
    {
        title: `Аналитика посадочных страниц`,
        subtitle: `Ежемесячно анализировали движение аудитории, конверсию по&nbsp;посадочным страницам. Аналитика показывала, насколько удачны наши меры продвижения.`,
    },
    {
        title: `Проверка исправлений по&nbsp;техническому аудиту`,
        subtitle: `Разработка и&nbsp;исправления по&nbsp;сайту были на&nbsp;стороне другого подрядчика, поэтому выполнение рекомендаций мы&nbsp;контролировали и&nbsp;проверяли по&nbsp;ходу работ подрядчика`,
    },
];

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="mts-invest-process" bigPaddings={true}>
                <div className="mts-invest-process__wrapper">
                    <div className="mts-invest-process__grid">
                        <div className="mts-invest-process__info">
                            <CommonTitle>Процесс</CommonTitle>
                            <CommonUsualText>
                                Стратегия продвижения состояла из&nbsp;таких этапов,&nbsp;как:
                            </CommonUsualText>
                        </div>
                        <div className="mts-invest-process__list">
                            {processList.map(({ title, subtitle }, index) => (
                                <ScrollAnimation
                                    key={index}
                                    animateIn="fadeIn"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <CommonCollapseItem
                                        index={++index}
                                        triggerText={parse(title)}
                                        content={parse(subtitle)}
                                        classParent={'mts-invest-process__collapse-item'}
                                        numberColor={'#e51908'}
                                    />
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
